import { motion } from "framer-motion";
import { Home, Users, Sparkles } from "lucide-react";
import { Reveal, staggerParent, staggerChild } from "./Reveal";

const CARDS = [
  {
    icon: Home,
    title: "I Live Here",
    body: "I have built my life in this community and understand the needs of local families and schools.",
  },
  {
    icon: Users,
    title: "I'm A Parent",
    body: "The decisions made today directly affect our children tomorrow.",
  },
  {
    icon: Sparkles,
    title: "A Fresh Voice",
    body: "New ideas, fresh perspectives, and leadership that listens can help strengthen our schools.",
  },
];

export const WhyRunning = () => {
  return (
    <section id="why" className="py-20 lg:py-28 bg-slate-50 border-y border-slate-100" data-testid="why-running-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-teal-600">Why I'm Running</p>
          <h2 className="font-display font-extrabold tracking-tight text-slate-900 text-3xl md:text-4xl lg:text-5xl mt-3 max-w-2xl leading-tight">
            Rooted in community, focused on students
          </h2>
        </Reveal>

        <motion.div
          variants={staggerParent}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid md:grid-cols-3 gap-6"
        >
          {CARDS.map((c) => (
            <motion.div
              key={c.title}
              variants={staggerChild}
              className="group rounded-2xl bg-white border border-slate-200 p-8 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-slate-900/5 transition-transform duration-300"
              data-testid={`why-card-${c.title.toLowerCase().replace(/[^a-z]/g, "")}`}
            >
              <div className="h-13 w-13 inline-flex items-center justify-center rounded-xl bg-teal-50 text-teal-700 p-3 group-hover:bg-teal-600 group-hover:text-white transition-colors">
                <c.icon size={26} strokeWidth={1.75} />
              </div>
              <h3 className="font-display text-2xl font-bold tracking-tight text-slate-900 mt-6">{c.title}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{c.body}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
